import React from 'react';
import Toast from 'react-bootstrap/Toast';
import './style.css'

const EventToast = ({type, show, setShow, message}) => {

	return (
		<div className="div-fixa">
			<Toast show={show} bg={type || 'danger'} onClose={() => setShow(false)} delay={3000} autohide>
				<Toast.Header className="toast-header" style={{backgroundColor: `rgba(var(--bs-${type || 'danger'}-rgb), var(--bs-bg-opacity))`}}>
					<strong className="me-auto">{(type === "danger" || !type) ? "Erro:" : "Mensagem:"}</strong>
				</Toast.Header>
				<Toast.Body className='text-white'>{message}</Toast.Body>
			</Toast>
		</div>
	);
}

export default EventToast;